import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "43",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F3B416",
      d: "M30.923 11.875v25.943A5.18 5.18 0 0 1 25.741 43H5.181A5.18 5.18 0 0 1 0 37.818V5.182A5.18 5.18 0 0 1 5.182 0h13.866z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F6CA5A",
      d: "M30.923 11.875H21.19a2.14 2.14 0 0 1-2.142-2.141V0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12.707 20.425v8.525h-1.2v-3.326c.024-.974.05-1.865.1-2.755l-.05-.025c-.244.68-.538 1.461-.832 2.242l-.747 1.94H8.76l-.74-1.94c-.293-.78-.587-1.562-.83-2.242l-.051.025c.033.89.075 1.78.1 2.755v3.326H6.03v-8.525h1.252l1.436 3.46a53 53 0 0 1 .621 1.688h.05c.135-.386.429-1.21.622-1.688l1.436-3.46zM19.283 23.18c0 1.789-.949 2.78-2.62 2.78h-1.025v2.998h-1.226v-8.533h2.25c1.664 0 2.621 1.016 2.621 2.755m-1.26 0c0-1.05-.453-1.588-1.377-1.588h-1.008v3.192h1.008c.932.008 1.377-.504 1.377-1.604M24.893 26.833h-.949v2.116h-1.159v-2.116h-3.023v-.63l1.763-5.77h1.185l-1.638 5.325h1.73l.126-2.99h1.016v2.998h.95z"
    }, null, -1)
  ])))
}
export default { render: render }